import { render, staticRenderFns } from "./TicketOverTimeConfig.vue?vue&type=template&id=62ecf43c"
import script from "./TicketOverTimeConfig.vue?vue&type=script&lang=js"
export * from "./TicketOverTimeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports